'use strict';

module.exports = function zip(array) {
  var _this = this;

  var values = array;

  if (values instanceof this.constructor) {
    values = values.all();
  }

  var collection = this.items.map(function (item, index) {
    return new _this.constructor([item, values[index]]);
  });
  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/zip.js
// module id = 1750
// module chunks = 2